import Api from "../../lib/api";
import { setMessage } from "../shared/notification/slice";
import { mapDeductionsToUi } from "./mapToUi";

export const getClientsOrganizations = async (filterValue) => {
    try {
        const response = filterValue
            ? await Api.get(`organizations`, { params: { "filter[q]": filterValue } })
            : await Api.get(`organizations`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get branch location`,
            isError: true,
        });
    }
};
export const getTruckTypeList = async (filterValue) => {
    try {
        const response = filterValue
            ? await Api.get(`truck-types`, { params: { "filter[q]": filterValue } })
            : await Api.get(`truck-types`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get Truck Types`,
            isError: true,
        });
    }
};
export const getTrucksList = async (filterValue, supplierId) => {
    try {
        const response = filterValue
            ? await Api.get(`trucks`, {
                  params: { "filter[q]": filterValue, "filter[supplierId]": supplierId },
              })
            : await Api.get(`trucks`, { params: { "filter[supplierId]": supplierId } });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get Truck Types`,
            isError: true,
        });
    }
};

export const getDriversList = async (filterValue, supplierId) => {
    try {
        const response = filterValue
            ? await Api.get(`drivers`, {
                  params: { "filter[q]": filterValue, "filter[supplierId]": supplierId },
              })
            : await Api.get(`drivers`, { params: { "filter[supplierId]": supplierId } });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get Drivers`,
            isError: true,
        });
    }
};

export const getPickupList = async (filterValue, organizationId) => {
    try {
        const response = filterValue
            ? await Api.get(`branches`, {
                  params: { "filter[organizationId]": organizationId, "filter[q]": filterValue },
              })
            : await Api.get(`branches`, { params: { "filter[organizationId]": organizationId } });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get Pickup Lists`,
            isError: true,
        });
    }
};
export const getSuppliersList = async (filterValue) => {
    try {
        const response = filterValue
            ? await Api.get(`suppliers`, {
                  params: { "filter[q]": filterValue },
              })
            : await Api.get(`suppliers`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get suppliers Lists`,
            isError: true,
        });
    }
};
export const getConstantsList = async () => {
    try {
        const response = await Api.get(`projects/constants`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get constants Lists`,
            isError: true,
        });
    }
};
export const getSectionsList = async () => {
    try {
        const response = await Api.get(`sections`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get sections List`,
            isError: true,
        });
    }
};
export const getItemsList = async (sectionId) => {
    try {
        const response = await Api.get(`items`, { params: { "filter[sectionId]": sectionId } });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get items List`,
            isError: true,
        });
    }
};
export const getStandardsAndProceduresList = async () => {
    try {
        const response = await Api.get(`standards-and-operational-procedures`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't standards and procedures`,
            isError: true,
        });
    }
};
export const submitProfileForm = async (formData) => {
    try {
        const response = await Api.post(`projects`, formData);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't Submit The Form`,
            isError: true,
        });
    }
};
export const submitSupplyChainForm = async (conditionId, events) => {
    try {
        const response = await Api.put(
            `monthly-project-truck-type-conditions/${conditionId}/update_status?event=${events}`
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't Submit The Form`,
            isError: true,
        });
    }
};
export const submitDeclineWorkingCondition = async (declineReason, conditionId) => {
    try {
        const response = await Api.put(
            `monthly-project-truck-type-conditions/${conditionId}/decline/`,
            declineReason
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't Submit The Form`,
            isError: true,
        });
    }
};
export const submitPricingForm = async (conditionId, data) => {
    try {
        const response = await Api.put(
            `monthly-project-truck-type-conditions/${conditionId}`,
            data
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't Submit The Form`,
            isError: true,
        });
    }
};
export const getProjectById = async (id) => {
    try {
        const response = await Api.get(`projects/${id}`, {
            params: {
                include:
                    "organization,creator,supplierAttachments,salesAttachments,operationalAttachments,targetPriceAttachments,projectPenaltiesAndDeductions.penaltiesAndDeduction,standardsAndOperationalProcedures",
            },
        });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get project profile `,
            isError: true,
        });
    }
};

export const updateProjectInfo = async (id, data) => {
    try {
        const response = await Api.put(`projects/${id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const uploadProjectInfoAttachments = async (data) => {
    try {
        const response = await Api.post(`attachments`, data);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't upload attachements`,
            isError: true,
        });
    }
};

export const deleteSingleAttachment = async (id) => {
    try {
        const response = await Api.delete(`attachments/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};
export const deleteAllAttachments = async () => {
    try {
        const response = await Api.delete(`attachments`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getClientById = async (id) => {
    try {
        const response = await Api.get(`organizations/${id}`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get organizations name `,
            isError: true,
        });
    }
};
export const getSalesConditionById = async (id) => {
    try {
        const response = await Api.get(`monthly-project-sales-conditions/${id}?sort=-createdAt`, {
            params: { include: "truckType,branch,objections" },
        });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get project profile conditions `,
            isError: true,
        });
    }
};
export const getSupplierConditionById = async (id) => {
    try {
        const response = await Api.get(
            `monthly-project-supplier-conditions/${id}?sort=-createdAt`,
            {
                params: {
                    include: "projectMonthlySuppliers,suppliers,truckType,branch,objections",
                },
            }
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get project profile conditions `,
            isError: true,
        });
    }
};
export const getConditionById = async (id) => {
    try {
        const response = await Api.get(`monthly-project-truck-type-conditions/${id}`, {
            params: { include: "truckType,branch,projectMonthlySuppliers,suppliers,objections" },
        });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't get project profile conditions `,
            isError: true,
        });
    }
};
export const updateProfileForm = async (id, data) => {
    try {
        const response = await Api.put(`monthly-project-sales-conditions/${id}`, data);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't update project profile conditions `,
            isError: true,
        });
    }
};
export const submitWorkingConditionForm = async (data) => {
    try {
        const response = await Api.post(`monthly-project-sales-conditions`, data);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't update project profile conditions `,
            isError: true,
        });
    }
};
export const updateProfileSupplierForm = async (id, data) => {
    try {
        const response = await Api.put(`monthly-project-supplier-conditions/${id}`, data);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't update project profile conditions `,
            isError: true,
        });
    }
};
export const deleteSupplierPerCondition = async (conditionId, supplierId) => {
    try {
        const response = await Api.delete(
            `monthly-project-supplier-conditions/${conditionId}/assigned-suppliers/${supplierId}`
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't update project profile conditions `,
            isError: true,
        });
    }
};
export const SubmitDeactivate = async (data, conditionId) => {
    try {
        const response = await Api.put(
            `monthly-project-sales-conditions/${conditionId}/deactivate`,
            data
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't Deactivate project profile conditions `,
            isError: true,
        });
    }
};
export const submitObjection = async (data) => {
    try {
        const response = await Api.post(`objections`, data);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't object on this working conditions `,
            isError: true,
        });
    }
};
export const getObjectionById = async (id) => {
    const includeEntities = "creator,item,section,comments,mentionedAdminUsers,comments.adminUser";
    try {
        const response = await Api.get(
            `objections/${id}?sort=comments.createdAt&include=${includeEntities}`
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't fetch the objection details `,
            isError: true,
        });
    }
};
export const getAdminsUsers = async () => {
    try {
        const response = await Api.get("admin-users", { params: { "page[size]": 50 } });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't fetch the objection details `,
            isError: true,
        });
    }
};
export const replyObjection = async (comment) => {
    try {
        const response = await Api.post("comments", comment);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't reply on the Objection `,
            isError: true,
        });
    }
};
export const solveObjection = async (ObjectionId) => {
    try {
        const response = await Api.get(`objections/${ObjectionId}/resolve`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve on the Objection `,
            isError: true,
        });
    }
};

export const getPenaltiesAndDeductions = async (filter) => {
    try {
        const response = await Api.get("penalties-and-deductions", {
            params: {
                ...(filter && { "filter[party]": filter }),
            },
        });
        return mapDeductionsToUi(response.entities.penaltiesAndDeductions);
    } catch (error) {
        return error;
    }
};

// export const getLiveTrackingTrips = async (page = 1, size = 10) => {
//     try {
//         const response = await Api.get(
//             `/trips?page[size]=${size}&page[number]=${page}&sort=-createdAt&filter[tripStatus]=active&include=driver,truck,truckType,tripPoints`
//         );
//         return response;
//     } catch (error) {
//         return error;
//     }
// };

export const getLiveTrackingTrips = async (page = 1, size = 10, selectedFilters, search) => {
    try {
        const params = {};

        if (selectedFilters.customers) {
            params["filter[client]"] = selectedFilters.customers;
        }

        if (selectedFilters.statuses) {
            params["filter[status]"] = selectedFilters.statuses;
        }

        if (selectedFilters.vehicles) {
            params["filter[truck_type_id]"] = selectedFilters.vehicles;
        }

        if (
            selectedFilters.tripNumber &&
            search &&
            search.trim() !== "" &&
            selectedFilters.tripNumber !== ""
        ) {
            params[`filter[${selectedFilters.tripNumber}]`] = search;
        }

        const response = await Api.get(
            `/trips?page[size]=${size}&page[number]=${page}&sort=-createdAt&filter[tripStatus]=active&include=driver,truck,truckType,tripPoints`,
            { params }
        );

        return response;
    } catch (error) {
        return error;
    }
};
